// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "chunk." + {"757": "0033610892a6d330","860": "6c8ba46a92ca4f15",}[chunkId] + ".js"
}